/* ==========================================================================
   NEW PRODUCT ITEM — behaviour (v4)
   Handles: the weight/variant dropdown (price + compare-price + which
   variant cart actions use), the add-to-cart control that starts as a
   single "+" button and expands into a [-] [qty] [+] stepper, and direct
   quantity editing (click the number, type, press Enter).

   v4: cards injected after page load (e.g. Recently Viewed) are now wired
   up too. theme.js dispatches 'npil:refresh' after inserting them.

   Cart quantities are synced from the real cart once on page load (so a
   product already in the cart shows the correct starting quantity), then
   kept in sync locally as the shopper interacts.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  // safety guard: if this script gets included more than once (e.g. its
  // <script> tag ends up inside a per-product loop instead of loaded once
  // in theme.liquid), only the first run does anything. Without this,
  // every click would fire multiple competing cart requests.
  if (window.__npilInitialized) return;
  window.__npilInitialized = true;

  var npilToastEl = null;
  function showToast(message, isError) {
    if (!npilToastEl) {
      npilToastEl = document.createElement('div');
      npilToastEl.className = 'npil-toast';
      document.body.appendChild(npilToastEl);
    }
    npilToastEl.textContent = message;
    npilToastEl.classList.toggle('npil-toast--error', !!isError);
    npilToastEl.classList.add('is-visible');
    clearTimeout(npilToastEl._hideTimer);
    npilToastEl._hideTimer = setTimeout(function () {
      npilToastEl.classList.remove('is-visible');
    }, 2500);
  }

  /* ---- slider arrows: any grid with class "npil-slider" gets left/right
     arrow buttons (no scrollbar). Works for grids that exist on page load
     and for grids injected later (recently viewed) via 'npil:refresh'. ---- */

  var ARROW_PREV = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeArrow(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'npil-slider-arrow npil-slider-arrow--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous products' : 'Next products');
    btn.innerHTML = dir === 'prev' ? ARROW_PREV : ARROW_NEXT;
    return btn;
  }

  function initSliders(scope) {
    (scope || document).querySelectorAll('.npil-slider').forEach(function (grid) {
      if (grid.getAttribute('data-npil-slider-ready') === 'true') return;
      grid.setAttribute('data-npil-slider-ready', 'true');

      var wrap = document.createElement('div');
      wrap.className = 'npil-slider-wrap';
      grid.parentNode.insertBefore(wrap, grid);
      wrap.appendChild(grid);

      var prev = makeArrow('prev');
      var next = makeArrow('next');
      wrap.appendChild(prev);
      wrap.appendChild(next);

      function update() {
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        wrap.classList.toggle('is-static', maxScroll <= 2);
        prev.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= maxScroll - 2;
      }

      function step(dir) {
        grid.scrollBy({ left: dir * grid.clientWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(grid);

      update();
      setTimeout(update, 400); // images/fonts can change the width after load
    });
  }

  initSliders(document);

  var qtyByVariant = {};

  // cart ek hi baar load hoti hai, phir har naye card group ko usi se init karte hain
  var cartReady = fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      if (cart && cart.items) {
        cart.items.forEach(function (line) {
          qtyByVariant[line.variant_id] = (qtyByVariant[line.variant_id] || 0) + line.quantity;
        });
      }
    })
    .catch(function () {});

  function initScope(scope) {
    (scope || document).querySelectorAll('[data-npil-item]').forEach(function (item) {
      setupItem(item, qtyByVariant); // already bound cards khud skip ho jate hain
    });
  }

  // page load par maujood cards
  cartReady.then(function () {
    initScope(document);
  });

  // baad mein inject hone wale cards (recently viewed, etc.)
  document.addEventListener('npil:refresh', function (e) {
    var scope = e && e.detail && e.detail.scope;
    initSliders(scope);
    cartReady.then(function () {
      initScope(scope);
    });
  });

  function setupItem(item, qtyByVariant) {
    // extra safety: never wire up the same card twice
    if (item.getAttribute('data-npil-bound') === 'true') return;
    item.setAttribute('data-npil-bound', 'true');

    var variantSelect = item.querySelector('[data-npil-variant-select]');
    var variantToggle = item.querySelector('[data-npil-variant-toggle]');
    var variantDropdown = item.querySelector('[data-npil-variant-dropdown]');
    var variantLabel = item.querySelector('[data-npil-variant-label]');
    var priceEl = item.querySelector('[data-npil-price]');
    var comparePriceEl = item.querySelector('[data-npil-compare-price]');

    var cartControl = item.querySelector('[data-npil-cart-control]');
    if (!cartControl) return;

    var addBtn = item.querySelector('[data-npil-add-btn]');
    var stepper = item.querySelector('[data-npil-stepper]');
    var qtyEl = item.querySelector('[data-npil-qty]');
    var minusBtn = item.querySelector('[data-npil-minus]');
    var plusBtn = item.querySelector('[data-npil-plus]');

    var currentVariantId = cartControl.getAttribute('data-variant-id');
    var busy = false;

    /* ---- variant dropdown ---- */

    if (variantToggle && variantDropdown) {
      variantToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = variantDropdown.classList.contains('is-open');

        document.querySelectorAll('.npil-variant-dropdown.is-open').forEach(function (dd) {
          dd.classList.remove('is-open');
        });
        document.querySelectorAll('.npil-variant-toggle.is-open').forEach(function (tg) {
          tg.classList.remove('is-open');
        });

        if (!isOpen) {
          variantDropdown.classList.add('is-open');
          variantToggle.classList.add('is-open');
        }
      });

      document.addEventListener('click', function (e) {
        if (variantSelect && !variantSelect.contains(e.target)) {
          variantDropdown.classList.remove('is-open');
          variantToggle.classList.remove('is-open');
        }
      });

      variantDropdown.querySelectorAll('[data-npil-variant-option]').forEach(function (option) {
        option.addEventListener('click', function () {
          if (option.getAttribute('data-available') === 'false') return;

          currentVariantId = option.getAttribute('data-variant-id');
          cartControl.setAttribute('data-variant-id', currentVariantId);

          if (variantLabel) variantLabel.textContent = option.getAttribute('data-variant-title');
          if (priceEl) priceEl.textContent = option.getAttribute('data-variant-price');

          if (comparePriceEl) {
            var comparePrice = option.getAttribute('data-variant-compare-price');
            if (comparePrice) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.hidden = false;
            } else {
              comparePriceEl.hidden = true;
            }
          }

          variantDropdown.querySelectorAll('[data-npil-variant-option]').forEach(function (o) {
            o.classList.remove('is-selected');
          });
          option.classList.add('is-selected');

          variantDropdown.classList.remove('is-open');
          variantToggle.classList.remove('is-open');

          // switching variant means the stepper now refers to a
          // different cart line - re-sync its quantity from the map
          currentLineQty = qtyByVariant[currentVariantId] || 0;
          updateQtyDisplay();
        });
      });
    }

    /* ---- cart stepper ---- */

    var currentLineQty = qtyByVariant[currentVariantId] || 0;
    var busyTimeout = null;

    function updateQtyDisplay() {
      if (qtyEl) qtyEl.value = currentLineQty;

      if (currentLineQty > 0) {
        if (addBtn) addBtn.hidden = true;
        if (stepper) stepper.hidden = false;
      } else {
        if (stepper) stepper.hidden = true;
        if (addBtn) addBtn.hidden = false;
      }
    }

    function setBusy(state) {
      busy = state;
      cartControl.classList.toggle('is-busy', state);

      // safety net: never let the controls stay stuck/disabled forever,
      // even if the network call is slow or never resolves
      if (busyTimeout) {
        clearTimeout(busyTimeout);
        busyTimeout = null;
      }
      if (state) {
        busyTimeout = setTimeout(function () {
          setBusy(false);
        }, 6000);
      }
    }

    function notifyCartChanged() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // let the rest of the theme (header cart icon, cart drawer, etc.)
          // know the cart changed, in case it listens for this
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

          // best-effort update of common header cart-count elements, if present
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    function addToCart() {
      if (busy) return;
      setBusy(true);

      // optimistic: update the UI immediately so it never feels stuck,
      // then sync with the server in the background
      var previousQty = currentLineQty;
      currentLineQty = currentLineQty + 1;
      qtyByVariant[currentVariantId] = currentLineQty;
      updateQtyDisplay();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariantId, quantity: 1 })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error((data && data.message) || 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          notifyCartChanged();
        })
        .catch(function (err) {
          // revert if the server call failed (e.g. out of stock / stock limit)
          currentLineQty = previousQty;
          qtyByVariant[currentVariantId] = currentLineQty;
          updateQtyDisplay();
          showToast((err && err.message) || 'Could not add to cart', true);
        })
        .finally(function () {
          setBusy(false);
        });
    }

    function changeQuantity(newQty) {
      if (busy) return;
      if (newQty === currentLineQty) return;
      setBusy(true);

      var previousQty = currentLineQty;
      currentLineQty = newQty;
      qtyByVariant[currentVariantId] = currentLineQty;
      updateQtyDisplay();

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariantId, quantity: newQty })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error((data && data.message) || 'Could not update quantity');
            return data;
          });
        })
        .then(function () {
          notifyCartChanged();
        })
        .catch(function (err) {
          currentLineQty = previousQty;
          qtyByVariant[currentVariantId] = currentLineQty;
          updateQtyDisplay();
          showToast((err && err.message) || 'Could not update quantity', true);
        })
        .finally(function () {
          setBusy(false);
        });
    }

    updateQtyDisplay();

    if (addBtn) {
      addBtn.addEventListener('click', addToCart);
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        changeQuantity(currentLineQty + 1);
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var next = currentLineQty - 1;
        changeQuantity(next > 0 ? next : 0);
      });
    }

    /* ---- direct quantity editing: click the number, type, press Enter ---- */

    if (qtyEl) {
      qtyEl.addEventListener('focus', function () {
        qtyEl.select();
      });

      qtyEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          qtyEl.blur();
        }
      });

      qtyEl.addEventListener('blur', function () {
        var parsed = parseInt(qtyEl.value, 10);
        if (isNaN(parsed) || parsed < 0) {
          updateQtyDisplay(); // invalid input - just reset to the real value
          return;
        }
        changeQuantity(parsed);
      });
    }

    /* ---- wishlist (local toggle only, no backend) ---- */

    var wishlistBtn = item.querySelector('[data-npil-wishlist]');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function () {
        wishlistBtn.classList.toggle('is-active');
      });
    }
  }
});
/* ==========================================================================
   Scroll arrows for product rows (Recently Viewed, etc.)
   Any grid with [data-npil-scroll] gets prev/next arrows. Works for grids
   injected after page load because it listens for 'npil:refresh'.
   ========================================================================== */
(function () {
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeBtn(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'npil-rv-arrow npil-rv-arrow--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous products' : 'Next products');
    btn.innerHTML = dir === 'prev' ? ICON_PREV : ICON_NEXT;
    return btn;
  }

  function enhance(grid) {
    if (!grid || grid.getAttribute('data-npil-scroll-bound') === 'true') return;
    grid.setAttribute('data-npil-scroll-bound', 'true');

    var wrap = document.createElement('div');
    wrap.className = 'npil-rv-wrap';
    grid.parentNode.insertBefore(wrap, grid);

    var prev = makeBtn('prev');
    var next = makeBtn('next');
    wrap.appendChild(prev);
    wrap.appendChild(grid);
    wrap.appendChild(next);

    function update() {
      var max = grid.scrollWidth - grid.clientWidth;
      var x = Math.abs(grid.scrollLeft);
      prev.classList.toggle('is-visible', x > 5);
      next.classList.toggle('is-visible', max > 5 && x < max - 5);
    }

    // moves exactly one product per click
    function go(dir) {
      var cards = grid.querySelectorAll('.npil-item');
      var step = grid.clientWidth * 0.8; // fallback

      if (cards.length > 1) {
        step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      } else if (cards.length === 1) {
        step = cards[0].getBoundingClientRect().width;
      }

      grid.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    setTimeout(update, 300);
    setTimeout(update, 1200); // after lazy images settle
    update();
  }

  function initScope(scope) {
    (scope || document).querySelectorAll('[data-npil-scroll]').forEach(enhance);
  }

  document.addEventListener('npil:refresh', function (e) {
    initScope(e && e.detail && e.detail.scope);
  });

  if (document.readyState !== 'loading') {
    initScope(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { initScope(document); });
  }
})();












// /* ==========================================================================
//    NEW PRODUCT ITEM — behaviour (v4)
//    Handles: the weight/variant dropdown (price + compare-price + which
//    variant cart actions use), the add-to-cart control that starts as a
//    single "+" button and expands into a [-] [qty] [+] stepper, and direct
//    quantity editing (click the number, type, press Enter).

//    v4: cards injected after page load (e.g. Recently Viewed) are now wired
//    up too. theme.js dispatches 'npil:refresh' after inserting them.

//    Cart quantities are synced from the real cart once on page load (so a
//    product already in the cart shows the correct starting quantity), then
//    kept in sync locally as the shopper interacts.
//    ========================================================================== */

// document.addEventListener('DOMContentLoaded', function () {
//   // safety guard: if this script gets included more than once (e.g. its
//   // <script> tag ends up inside a per-product loop instead of loaded once
//   // in theme.liquid), only the first run does anything. Without this,
//   // every click would fire multiple competing cart requests.
//   if (window.__npilInitialized) return;
//   window.__npilInitialized = true;

//   var npilToastEl = null;
//   function showToast(message, isError) {
//     if (!npilToastEl) {
//       npilToastEl = document.createElement('div');
//       npilToastEl.className = 'npil-toast';
//       document.body.appendChild(npilToastEl);
//     }
//     npilToastEl.textContent = message;
//     npilToastEl.classList.toggle('npil-toast--error', !!isError);
//     npilToastEl.classList.add('is-visible');
//     clearTimeout(npilToastEl._hideTimer);
//     npilToastEl._hideTimer = setTimeout(function () {
//       npilToastEl.classList.remove('is-visible');
//     }, 2500);
//   }

//   var qtyByVariant = {};

//   // cart ek hi baar load hoti hai, phir har naye card group ko usi se init karte hain
//   var cartReady = fetch('/cart.js')
//     .then(function (res) {
//       return res.json();
//     })
//     .then(function (cart) {
//       if (cart && cart.items) {
//         cart.items.forEach(function (line) {
//           qtyByVariant[line.variant_id] = (qtyByVariant[line.variant_id] || 0) + line.quantity;
//         });
//       }
//     })
//     .catch(function () {});

//   function initScope(scope) {
//     (scope || document).querySelectorAll('[data-npil-item]').forEach(function (item) {
//       setupItem(item, qtyByVariant); // already bound cards khud skip ho jate hain
//     });
//   }

//   // page load par maujood cards
//   cartReady.then(function () {
//     initScope(document);
//   });

//   // baad mein inject hone wale cards (recently viewed, etc.)
//   document.addEventListener('npil:refresh', function (e) {
//     var scope = e && e.detail && e.detail.scope;
//     cartReady.then(function () {
//       initScope(scope);
//     });
//   });

//   function setupItem(item, qtyByVariant) {
//     // extra safety: never wire up the same card twice
//     if (item.getAttribute('data-npil-bound') === 'true') return;
//     item.setAttribute('data-npil-bound', 'true');

//     var variantSelect = item.querySelector('[data-npil-variant-select]');
//     var variantToggle = item.querySelector('[data-npil-variant-toggle]');
//     var variantDropdown = item.querySelector('[data-npil-variant-dropdown]');
//     var variantLabel = item.querySelector('[data-npil-variant-label]');
//     var priceEl = item.querySelector('[data-npil-price]');
//     var comparePriceEl = item.querySelector('[data-npil-compare-price]');

//     var cartControl = item.querySelector('[data-npil-cart-control]');
//     if (!cartControl) return;

//     var addBtn = item.querySelector('[data-npil-add-btn]');
//     var stepper = item.querySelector('[data-npil-stepper]');
//     var qtyEl = item.querySelector('[data-npil-qty]');
//     var minusBtn = item.querySelector('[data-npil-minus]');
//     var plusBtn = item.querySelector('[data-npil-plus]');

//     var currentVariantId = cartControl.getAttribute('data-variant-id');
//     var busy = false;

//     /* ---- variant dropdown ---- */

//     if (variantToggle && variantDropdown) {
//       variantToggle.addEventListener('click', function (e) {
//         e.stopPropagation();
//         var isOpen = variantDropdown.classList.contains('is-open');

//         document.querySelectorAll('.npil-variant-dropdown.is-open').forEach(function (dd) {
//           dd.classList.remove('is-open');
//         });
//         document.querySelectorAll('.npil-variant-toggle.is-open').forEach(function (tg) {
//           tg.classList.remove('is-open');
//         });

//         if (!isOpen) {
//           variantDropdown.classList.add('is-open');
//           variantToggle.classList.add('is-open');
//         }
//       });

//       document.addEventListener('click', function (e) {
//         if (variantSelect && !variantSelect.contains(e.target)) {
//           variantDropdown.classList.remove('is-open');
//           variantToggle.classList.remove('is-open');
//         }
//       });

//       variantDropdown.querySelectorAll('[data-npil-variant-option]').forEach(function (option) {
//         option.addEventListener('click', function () {
//           if (option.getAttribute('data-available') === 'false') return;

//           currentVariantId = option.getAttribute('data-variant-id');
//           cartControl.setAttribute('data-variant-id', currentVariantId);

//           if (variantLabel) variantLabel.textContent = option.getAttribute('data-variant-title');
//           if (priceEl) priceEl.textContent = option.getAttribute('data-variant-price');

//           if (comparePriceEl) {
//             var comparePrice = option.getAttribute('data-variant-compare-price');
//             if (comparePrice) {
//               comparePriceEl.textContent = comparePrice;
//               comparePriceEl.hidden = false;
//             } else {
//               comparePriceEl.hidden = true;
//             }
//           }

//           variantDropdown.querySelectorAll('[data-npil-variant-option]').forEach(function (o) {
//             o.classList.remove('is-selected');
//           });
//           option.classList.add('is-selected');

//           variantDropdown.classList.remove('is-open');
//           variantToggle.classList.remove('is-open');

//           // switching variant means the stepper now refers to a
//           // different cart line - re-sync its quantity from the map
//           currentLineQty = qtyByVariant[currentVariantId] || 0;
//           updateQtyDisplay();
//         });
//       });
//     }

//     /* ---- cart stepper ---- */

//     var currentLineQty = qtyByVariant[currentVariantId] || 0;
//     var busyTimeout = null;

//     function updateQtyDisplay() {
//       if (qtyEl) qtyEl.value = currentLineQty;

//       if (currentLineQty > 0) {
//         if (addBtn) addBtn.hidden = true;
//         if (stepper) stepper.hidden = false;
//       } else {
//         if (stepper) stepper.hidden = true;
//         if (addBtn) addBtn.hidden = false;
//       }
//     }

//     function setBusy(state) {
//       busy = state;
//       cartControl.classList.toggle('is-busy', state);

//       // safety net: never let the controls stay stuck/disabled forever,
//       // even if the network call is slow or never resolves
//       if (busyTimeout) {
//         clearTimeout(busyTimeout);
//         busyTimeout = null;
//       }
//       if (state) {
//         busyTimeout = setTimeout(function () {
//           setBusy(false);
//         }, 6000);
//       }
//     }

//     function notifyCartChanged() {
//       fetch('/cart.js')
//         .then(function (res) { return res.json(); })
//         .then(function (cart) {
//           // let the rest of the theme (header cart icon, cart drawer, etc.)
//           // know the cart changed, in case it listens for this
//           document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

//           // best-effort update of common header cart-count elements, if present
//           document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count').forEach(function (el) {
//             el.textContent = cart.item_count;
//           });
//         })
//         .catch(function () {});
//     }

//     function addToCart() {
//       if (busy) return;
//       setBusy(true);

//       // optimistic: update the UI immediately so it never feels stuck,
//       // then sync with the server in the background
//       var previousQty = currentLineQty;
//       currentLineQty = currentLineQty + 1;
//       qtyByVariant[currentVariantId] = currentLineQty;
//       updateQtyDisplay();

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: currentVariantId, quantity: 1 })
//       })
//         .then(function (res) {
//           return res.json().then(function (data) {
//             if (!res.ok) throw new Error((data && data.message) || 'Could not add to cart');
//             return data;
//           });
//         })
//         .then(function () {
//           notifyCartChanged();
//         })
//         .catch(function (err) {
//           // revert if the server call failed (e.g. out of stock / stock limit)
//           currentLineQty = previousQty;
//           qtyByVariant[currentVariantId] = currentLineQty;
//           updateQtyDisplay();
//           showToast((err && err.message) || 'Could not add to cart', true);
//         })
//         .finally(function () {
//           setBusy(false);
//         });
//     }

//     function changeQuantity(newQty) {
//       if (busy) return;
//       if (newQty === currentLineQty) return;
//       setBusy(true);

//       var previousQty = currentLineQty;
//       currentLineQty = newQty;
//       qtyByVariant[currentVariantId] = currentLineQty;
//       updateQtyDisplay();

//       fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: currentVariantId, quantity: newQty })
//       })
//         .then(function (res) {
//           return res.json().then(function (data) {
//             if (!res.ok) throw new Error((data && data.message) || 'Could not update quantity');
//             return data;
//           });
//         })
//         .then(function () {
//           notifyCartChanged();
//         })
//         .catch(function (err) {
//           currentLineQty = previousQty;
//           qtyByVariant[currentVariantId] = currentLineQty;
//           updateQtyDisplay();
//           showToast((err && err.message) || 'Could not update quantity', true);
//         })
//         .finally(function () {
//           setBusy(false);
//         });
//     }

//     updateQtyDisplay();

//     if (addBtn) {
//       addBtn.addEventListener('click', addToCart);
//     }

//     if (plusBtn) {
//       plusBtn.addEventListener('click', function () {
//         changeQuantity(currentLineQty + 1);
//       });
//     }

//     if (minusBtn) {
//       minusBtn.addEventListener('click', function () {
//         var next = currentLineQty - 1;
//         changeQuantity(next > 0 ? next : 0);
//       });
//     }

//     /* ---- direct quantity editing: click the number, type, press Enter ---- */

//     if (qtyEl) {
//       qtyEl.addEventListener('focus', function () {
//         qtyEl.select();
//       });

//       qtyEl.addEventListener('keydown', function (e) {
//         if (e.key === 'Enter') {
//           e.preventDefault();
//           qtyEl.blur();
//         }
//       });

//       qtyEl.addEventListener('blur', function () {
//         var parsed = parseInt(qtyEl.value, 10);
//         if (isNaN(parsed) || parsed < 0) {
//           updateQtyDisplay(); // invalid input - just reset to the real value
//           return;
//         }
//         changeQuantity(parsed);
//       });
//     }

//     /* ---- wishlist (local toggle only, no backend) ---- */

//     var wishlistBtn = item.querySelector('[data-npil-wishlist]');
//     if (wishlistBtn) {
//       wishlistBtn.addEventListener('click', function () {
//         wishlistBtn.classList.toggle('is-active');
//       });
//     }
//   }
// });